import React from "react";
import { formatDateWithWeekDay, getConfiguration, getCurrencySymbol, getPrintableAmount, getSplitDesc, oddToString } from "../../data/utils";
import { useFetchNew } from "../../data/fetch/useFetch";
import { getLabel } from "../../InitData";
import BarcodeImg from "../../data/barcode-image/BarcodeImg";
import ErrorMessage from "../ErrorMessage";
import { BetslipContext } from "../../data/betslip/BetslipConf";
import { closeParentModal } from "../Modal";
import { ReservationPrinter } from "../../data/betslip/reservation-detail/ReservationPrinter";

export default function BookedTicket(props) {
    const conf = getConfiguration();
    const reservationCode = props.reservationCode;
    const betslipContext = React.useContext(BetslipContext);
    const [printing, setPrinting] = React.useState(false);
    const [isLoading, isError, data] = useFetchNew(conf.api.reloadReservation, {reservationCode}, (data) =>
        data
    );
    
    if (isLoading || isError) {
        return null;
    }

    if (data.code < 0) {
        return <ErrorMessage text={data.description} />;
    }

	function print(){
		setPrinting(true);
	}
	function endPrintFunction(){
		setPrinting(false);
	}
	function reload(e){
		betslipContext.reloadReservedTicket(null, data);
		closeParentModal(e);
	}
    try {
        const ticket = JSON.parse(data.object);
        let stake = null;
        if(ticket.selectedContainer !== 'systembets'){
        	stake = getPrintableAmount(ticket.amountMulti, conf.cs.m, conf.cs.nd);
        }
        else {
        	stake = getPrintableAmount(ticket.amountSystem, conf.cs.m, conf.cs.nd);
        }
	     // MAX PAID STUFF, IF THE CUSTOMER HAS IT IN ITS CONFIGURATION
	    let maxPaidPotentialWinning = null;
	    /*
	    let maxPaidPotentialWinMin =  null;
	    let maxPaidPotentialWinMax =  null;
	    let maxPaidStakeTaxedPotentialWinning = null;*/
	    
	    if(ticket.selectedContainer === 'systembets' ){
	    	if(conf.sbmw !== 0 && conf.mwspw){
	    		if(ticket.potentialWinning > conf.sbmw){
	    			maxPaidPotentialWinning = conf.sbmw
	    		}
	    		/*
	    		if(coupon.minPotentialWinning > conf.sbmw){
	    			maxPaidPotentialWinMin = getPrintableAmount(conf.sbmw, conf.cs.m, conf.cs.nd);
	    		}
	    		if(coupon.maxPotentialWinning > conf.sbmw){
	    			maxPaidPotentialWinMax = getPrintableAmount(conf.sbmw, conf.cs.m, conf.cs.nd);
	    		}
	    		if(coupon.stakeTaxedPotentialWinning > conf.sbmw){
	    			maxPaidStakeTaxedPotentialWinning = getPrintableAmount(conf.sbmw, conf.cs.m, conf.cs.nd);
	    		}*/
	    	}
	    }
	    else{
	    	if(conf.mbmw !== 0 && conf.mwmpw){
	    		if(ticket.potentialWinning > conf.mbmw){
	    			maxPaidPotentialWinning = conf.mbmw;
	    		}
	    		/*
	    		if(coupon.stakeTaxedPotentialWinning > conf.mbmw){
	    			maxPaidStakeTaxedPotentialWinning = getPrintableAmount(conf.mbmw, conf.cs.m, conf.cs.nd);
	    		}*/
	    	}
	    }       
        const potentialWinnings = getPrintableAmount(maxPaidPotentialWinning || ticket.potentialWinning, conf.cs.m, conf.cs.nd);
        const currency = getCurrencySymbol(conf.cs.ct);
    
        return (
            <div className="c_51">
            	{printing && <ReservationPrinter codeList={[reservationCode]} endFunction={() => { endPrintFunction(); }} /> }
                <div className="c_51_1">
                    <div className="c_51_1_1">
                        <div className="c_51_1_1_1">{getLabel('reservation_detail.events_number')}:</div>
                        <div className="c_51_1_1_2">{ticket.totalDraws}</div>
                    </div>
                    <div className="c_51_1_1">
                        <div className="c_51_1_1_1">{getLabel('reservation_detail.total_odds')}:</div>
                        <div className="c_51_1_1_2">{ticket.totalOdd}</div>
                    </div>
                </div>
                <div className="c_51_2">
    
                </div>
                <div className="c_51_3">
                    {ticket.selections.map(s => {
                        const formattedDate = formatDateWithWeekDay(s.timestamp).dayTime;
                        const [date, time] = getSplitDesc(formattedDate);
                        const [team1, team2] = getSplitDesc(s.descEvent);
                        return (
                            <div className="c_51_3_1" key={`${s.pal}_${s.avv}`}>
                                <div className="c_51_3_1_1">{date} {time}</div>
                                <div className="c_51_3_1_2"></div>
                                <div className="c_51_3_1_3">{s.alias}</div>
                                <div className="c_51_3_1_4">{team1} - {team2}</div>
                                {s.bets.map(b => {
                                    return (
                                        <React.Fragment key={`${b.scomSogei}_${b.handicap}`}>
                                            <div className="c_51_3_1_5">{b.descBet}</div>
                                            <div className="c_51_3_1_6">{b.descDraw}</div>
                                            <div className="c_51_3_1_7">{oddToString(b.odd)}</div>
                                        </React.Fragment>
                                    );
                                })}
                            </div>
                        );
                    })}
                </div>
                <div className="c_51_4">
                    <div className="c_51_4_1">
                        <BarcodeImg source={reservationCode} showValue={true} />
                    </div>
                    <div className="c_51_4_2">
                       {getLabel('reservation.disclaimer_for_agency')}
                    </div>
                    <div className="c_51_4_3">
                        <div className="c_51_4_3_1">
                            {
                            	ticket.selectedContainer !== 'systembets' && <>
                        			<div className="c_51_4_3_1_1">{getLabel('reservation_detail.total_odds')}</div>
                            		<div className="c_51_4_3_1_2">{ticket.totalOdd}</div>                           	
                            	</>
                            }
     
                            <div className="c_51_4_3_1_1">{getLabel('mybets.stake')}</div>
                            <div className="c_51_4_3_1_2">{stake} {currency}</div>
                            <div className="c_51_4_3_1_1">{getLabel('mybets.vincitapotenziale')}</div>
                            <div className="c_51_4_3_1_2">{potentialWinnings}</div>
                        </div>
                    </div>
                    <div className="c_51_4_4">
                        <button onClick={(e) => reload(e)} type="button" className="c_52">
                            <div className="c_52_1">{getLabel('reservation.reload_in_betslip')}</div>
                        </button>
                        <button type="button" onClick={print} className="c_53">
                            <div className="c_53_1">{getLabel('reservation_detail.print')}</div>
                        </button>
                    </div>
                </div>
            </div>
        );
    } catch (e) {
        console.error(e);
        return <ErrorMessage text='Errore' />;
    }
}
